import { makeAutoObservable, runInAction } from 'mobx'
import { logger } from 'shared/lib'
import { IntegrationsApi } from 'entities/Integrations'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { AircallNumbersListStore } from './AircallNumbersListStore'

export class AircallNumbersStore {
  private _aircallLink = ''
  private _numbersListStore: AircallNumbersListStore
  private _activeTabKey = 'assigned'

  constructor(private _entities: IEntitiesStore) {
    this._numbersListStore = new AircallNumbersListStore(this._entities)
    makeAutoObservable(this)
  }

  init = async () => {
    await this.loadAircallLink()
    this._numbersListStore.init()
  }

  private loadAircallLink = async () => {
    try {
      const { data } = await IntegrationsApi.getAirCallIntegrationLink()
      runInAction(() => {
        this._aircallLink = data
      })
    } catch (error) {
      logger.error(error)
    }
  }

  setActiveTabKey = (tabKey: string) => {
    this._activeTabKey = tabKey
    this._numbersListStore.setSearch('')
  }

  get aircallLink() {
    return this._aircallLink
  }

  get numbersListStore() {
    return this._numbersListStore
  }

  get activeTabKey() {
    return this._activeTabKey
  }
}
